// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"Attachments_toggleButton__29VmG"};